import { render, staticRenderFns } from "./Terpenes.vue?vue&type=template&id=d1bcaf70"
import script from "./Terpenes.vue?vue&type=script&lang=js"
export * from "./Terpenes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports